import { IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useAnalytics } from '@/hooks/useAnalytics';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import { useNavigationPreviousPage } from '@/hooks/useNavigationPreviousPage';
import { BodySmallMidEmphasis } from '@/design-system';
import styles from './BackButtonDark.styles';

interface BackButtonProps {
  trackId: string;
  text?: string;
  onClick?: () => void;
  size?: number;
}

export const BackButtonDark: React.FC<BackButtonProps> = ({
  text,
  trackId,
  onClick,
  size = 20,
}) => {
  const navigatePreviousPage = useNavigationPreviousPage();
  const { track } = useAnalytics();

  const goBack = () => {
    track({
      action: GenericTrackTypes.BUTTON_PRESSED,
      category: `${trackId}:back_button`,
      label: 'Back Button',
    });
    if (onClick) {
      onClick();
    } else {
      navigatePreviousPage();
    }
  };

  return (
    <div className={styles.backButtton} onClick={goBack}>
      <IconButton aria-label="Back button" data-testid="backButton">
        <KeyboardArrowLeftIcon sx={{ fontSize: size }} />
      </IconButton>
      <BodySmallMidEmphasis className={styles.backButtonText}>{text}</BodySmallMidEmphasis>
    </div>
  );
};
